var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOntapDndSmallDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5) translate(-1 -0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff",
    stroke: "#e8e8e8",
    transform: "translate(1 0.5)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#c8c8c8",
    fillRule: "evenodd",
    d: "M18 34.731h6.613v-8.239h3.775v8.238H35V21H18z",
    transform: "translate(8.293 10.352) translate(-0.293 -0.236) translate(-13.5 -17.616)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntapDndSmallDisabled);
export default __webpack_public_path__ + "static/media/ontap-dnd-small-disabled.bc1202e8071ea8eebe7aafdf37a6d0a0.svg";
export { ForwardRef as ReactComponent };